<template>
    <div class="d-flex flex-column">
        <page-loading-spinner :is-initial-loading="false" :is-refresh-loading="isRefreshLoading" />

        <button
            class="btn btn-primary w-100"
            :aria-label="offerNameAccessibility"
            :data-oevent-category="trackingCategory"
            :data-oevent-action="formattedTrackingAction"
            :data-oevent-label="trackingLabel"
            @click="handleAddToCart"
        >
            {{ label }}
        </button>

        <div class="row">
            <with-device-popin
                :id="popinId"
                :with-device-section="popinCtasDto.withDeviceSection"
                :without-device-section="popinCtasDto.withoutDeviceSection"
                :title="popinCtasDto.title"
                :description="popinCtasDto.description"
                :visual="popinCtasDto.visual"
            />
        </div>
    </div>
</template>
<script>
import WithDevicePopin from "./WithDevicePopin.vue";
import {CartService} from "../../../showcase/services/CartService";
import PageLoadingSpinner from "../../../common/components/custom/PageLoadingSpinner.vue";

export default {
    name:"OfferCtaCartWithDevicePopin",
    components: {
        PageLoadingSpinner,
        WithDevicePopin
    },
    props: {
        label: {
            type: String,
            required: true
        },
        link: {
            type: String,
            required: true
        },
        popinId: {
            type: String,
            required: true
        },
        popinCtasDto: {
            type: Object,
            required: true
        },
        offerName: {
            type: String,
            required: true
        },
        trackingCategory: {
            type: String,
            required: true
        },
        trackingLabel: {
            type: String,
            required: true
        },
        trackingAction: {
            type: String,
            required: false,
            default: ""
        },
    },
    data() {
        return {
            isRefreshLoading: false,
        }
    },
    computed: {
        offerNameAccessibility() {
            let offerNameAccessibilityLabel = this.offerName
                ? this.offerName
                    .replace(/Mo/g, ' méga Octet')
                    .replace(/Go/g, ' giga Octet')
                : '';
            return "Choisir le forfait " + offerNameAccessibilityLabel;
        },
        formattedTrackingAction() {
            const actionLabel = this.trackingAction ? this.trackingAction : this.label;
            return stripAccents(actionLabel).split(' ').join('_');
        },
    },
    methods: {
        async handleAddToCart() {
            this.isRefreshLoading = true;
            const urlParams = new URLSearchParams(new URL(this.link, window.location.origin).search);
            const id = urlParams.get('id');
            const universe = urlParams.get('universe');

            if (!id || !universe) {
                console.error('Missing id or universe in link');
                return;
            }

            const response = await CartService.setCart({
                id: id,
                universe: universe
            });

            this.isRefreshLoading = false;
            if (response.redirectUrl) {
                $('#' + this.popinId).modal('show');
            }
        },
    }
}
</script>
